(function() {
	/**
	 * Renders all publication items on publication page
	 * @param {Object} props - Page context and properties
	 * @returns {object} Promise
	 */
	WebBaseAprovLV.renderPublicationsPage = function(props) {
		var params = {
			page: props.context.params.page || '',
			detail: props.context.params.detail || ''
		};
		var model = {
			element: null,
			template: 'templates/publications.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				pageRaw: null,
				publicationsRaw: null,
				pageContent: null,
				publications: null,
				categories: [
					{
						codename: 'publikationen_pubblicazioni',
						name: 'Publikationen|Pubblicazioni'
					}
				],
				queryStringCollection: null,
				queryString: null
			}
		};
		var queryStringDict = WebBaseAprovLV.Utils.parseQuerystring(props.context.querystring);
		return $.when(
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page),
			(function() {
				var cache = WebBaseAprovLV.Cache.get('taxonomies.publications_categories').value;
				if (cache) {
					return $.Deferred().resolve(cache).promise();
				}
				return WebBaseAprovLV.Utils.getTaxonomies({groupname: 'publications_categories'});
			})()
		)
		.then(function(pageXhr, taxonomiesXhr) {
			var pageRaw = Array.isArray(pageXhr) ? pageXhr[0] : pageXhr;
			var taxonomies = Array.isArray(taxonomiesXhr) ? taxonomiesXhr[0] : taxonomiesXhr;
			var limit = WebBaseAprovLV.pagingWindow || 10;
			var filters = {
				categories: (queryStringDict.categories || '').toLowerCase(),
				month: parseInt((queryStringDict.month || '0').replace(/[^0-9]/g, ''), 10),
				year: parseInt((queryStringDict.year || '0').replace(/[^0-9]/g, ''), 10)
			};
			var categoryQueries = [];
			var categoryQueryString = '';
			var dateQueryString = [];
			var orderParam = {};
			var orderQueries = [];
			var orderQueryString = '';
			var publSettings;
			(taxonomies.terms || []).length && (model.data.categories = taxonomies.terms);
			WebBaseAprovLV.Cache.set('taxonomies.publications_categories', taxonomies);
			if (pageRaw.items && Array.isArray(pageRaw.items) && pageRaw.items.length) {
				model.data.pageRaw = pageRaw || {};
				model.data.pageContent = WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {};
				publSettings = (model.data.pageContent.container || []).filter(function(item) {
					return /publication_container/i.test(item.system_type || '');
				});
				if (publSettings.length > 0 && (publSettings[0].order__order || []).length > 0) {
					switch ((publSettings[0].order__order[0].codename || '')) {
						case 'title_asc':
							orderParam = {
								field: 'title',
								dir: 'asc'
							};
							break;
						case 'title_desc':
							orderParam = {
								field: 'title',
								dir: 'desc'
							};
							break;
						case 'date_time_asc':
							orderParam = {
								field: 'date_time',
								dir: 'asc'
							};
							break;
						case 'date_time_desc':
							orderParam = {
								field: 'date_time',
								dir: 'desc'
							};
							break;
					}
				}
				if ((queryStringDict.order || '').length) {
					orderParam.field = queryStringDict.order.toLowerCase();
				}
				if ((queryStringDict.dir || '').length) {
					orderParam.dir = queryStringDict.dir.toLowerCase();
				}
				// Category filter:
				if (filters.categories.length) {
					categoryQueries = model.data.categories.filter(function(item) {
						return (new RegExp('(^|,)' + item.codename + '(,|$)', 'i')).test(filters.categories);
					}).map(function(item) {
						return item.codename;
					});
					if (categoryQueries.length) {
						categoryQueryString = '&elements.publication_categories';
						if (categoryQueries.length === 1) {
							categoryQueryString += '[contains]=' + encodeURIComponent(categoryQueries[0]);
						} else {
							categoryQueryString += '[any]=' + encodeURIComponent(categoryQueries.join(','));
						}
					}
				}
				// Date filter:
				if (filters.year > 0 && filters.month >= 0) {
					dateQueryString = ['&elements.date_time[gte]=', (new Date(filters.year, filters.month - 1, 1)).toISOString()].join('');
				}
				// Order:
				orderQueries = [orderParam].map(function(item) {
					item.dir = /^(asc|desc)$/i.test(item.dir || '') ? item.dir : '';
					switch (item.field) {
						case 'last_modified':
							item.dir = item.dir.length ? item.dir : 'desc';
							item.value = ['system.last_modified[', item.dir, ']'].join('');
							break;
						case 'title':
							item.dir = item.dir.length ? item.dir : 'asc';
							item.value = ['elements.title[', item.dir, ']'].join('');
							break;
						case 'date_time':
							item.dir = item.dir.length ? item.dir : 'desc';
							item.value = ['elements.date_time[' + item.dir + ']'];
							break;
						default:
							item.dir = item.dir.length ? item.dir : 'asc';
							item.value = ['elements.date_time[', item.dir, ']'].join('');
					}
					return item;
				}).filter(function(item) {
					return (item.value || '').length > 0;
				}).map(function(item) {
					return item.value;
				});
				if (filters.year > 0 && filters.month >= 0) {
					orderQueryString = '&order=elements.date_time[asc]';
				} else {
					orderQueryString = orderQueries.length ? '&order=' + orderQueries.join(',') : '';
				}
				return WebBaseAprovLV.Utils.getKKData('?system.type=publication_item&includeTotalCount=true' + dateQueryString + categoryQueryString + orderQueryString + (queryStringDict.skip ? '&skip=' + queryStringDict.skip : '') + '&limit=' + limit);
			}
			return $.Deferred().reject(model);
		}).then(function(publicationsRaw) {
			var key;
			var params = [];
			var paramsDict = {};
			publicationsRaw = publicationsRaw || {};
			model.data.publicationsRaw = publicationsRaw || {};
			if (model.data.pageRaw) {
				// preserve non paging relevant querystring params
				for (key in queryStringDict) {
					switch (true) {
						case /^(skip|limit)/i.test(key):
							break;
						default:
							params.push([key.toLowerCase(), queryStringDict[key]].join('='));
							paramsDict[key.toLowerCase()] = queryStringDict[key];
							break;
					}
				}
				model.element = $('#content');
				model.data = $.extend(model.data, {
					publications: (model.data.publicationsRaw.items || []).length ? WebBaseAprovLV.Utils.getKKViewModel(model.data.publicationsRaw) : [],
					queryStringCollection: paramsDict,
					queryString: params.join('&')
				});
				return WebBaseAprovLV.Utils.transitionTo(model);
			}
			return $.Deferred().reject(model);
		}).promise();
	};
})();

